var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.182A2.935 2.935 0 014.932 4.25h30.136A2.935 2.935 0 0138 7.182c0 .675-.232 1.329-.66 1.85L25.624 23.41V33.48a2.275 2.275 0 01-3.684 1.779l-6.504-5.161a2.8 2.8 0 01-1.062-2.2V23.41L2.661 9.031A2.905 2.905 0 012 7.182zm3.867.443L17.37 21.744c.246.302.38.675.38 1.069v4.809l4.5 3.572v-8.381c0-.387.134-.767.38-1.07L34.133 7.626H5.867z"
  })));
}
export default SvgFilterInline;